// Thumbnail Helpers
export const getHeightAndWidthFromDataUrl = dataUrl =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        height: img.height,
        width: img.width,
      });
    };
    img.onerror = () =>
      reject(new Error("dataUrl not valid; unable to load image: ", dataUrl));
    img.src = dataUrl;
  });

const getThumbnailErrorMessage = media =>
  media?.mediaType === "collection"
    ? "Image height should be at least 264px"
    : "Image should be at least 264px x 264px.";

export const validateThumbnailSize = async (media, dataUrl) => {
  const { height, width } = await getHeightAndWidthFromDataUrl(dataUrl);
  const notValid =
    media?.mediaType === "collection"
      ? height < 264
      : height < 264 || width < 264;

  if (notValid) {
    const errorMessage = getThumbnailErrorMessage(media);
    throw new Error(`Image provided is too small. ${errorMessage}`);
  }
};
